// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateOrganizationApiSettingsMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  mcpEnabled: Types.Scalars["Boolean"]["input"];
}>;

export type UpdateOrganizationApiSettingsMutation = {
  __typename?: "Mutation";
  updateOrganizationApiSettings: {
    __typename?: "Organization";
    id: string;
    mcpEnabled: boolean;
  };
};

export const UpdateOrganizationApiSettingsDocument = gql`
  mutation UpdateOrganizationApiSettings(
    $organizationSlug: ID!
    $mcpEnabled: Boolean!
  ) {
    updateOrganizationApiSettings(
      organizationSlug: $organizationSlug
      mcpEnabled: $mcpEnabled
    ) {
      id
      mcpEnabled
    }
  }
`;
export type UpdateOrganizationApiSettingsMutationFn = Apollo.MutationFunction<
  UpdateOrganizationApiSettingsMutation,
  UpdateOrganizationApiSettingsMutationVariables
>;

/**
 * __useUpdateOrganizationApiSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationApiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationApiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationApiSettingsMutation, { data, loading, error }] = useUpdateOrganizationApiSettingsMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      mcpEnabled: // value for 'mcpEnabled'
 *   },
 * });
 */
export function useUpdateOrganizationApiSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationApiSettingsMutation,
    UpdateOrganizationApiSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationApiSettingsMutation,
    UpdateOrganizationApiSettingsMutationVariables
  >(UpdateOrganizationApiSettingsDocument, options);
}
export type UpdateOrganizationApiSettingsMutationHookResult = ReturnType<
  typeof useUpdateOrganizationApiSettingsMutation
>;
export type UpdateOrganizationApiSettingsMutationResult =
  Apollo.MutationResult<UpdateOrganizationApiSettingsMutation>;
export type UpdateOrganizationApiSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOrganizationApiSettingsMutation,
    UpdateOrganizationApiSettingsMutationVariables
  >;
